export default __webpack_public_path__ + "static/primary-1284c02449d5bc804a04a174c2de2e84.jpg";